import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import _ from "lodash";
import cx from "classnames";
import styles from "./dashboard.module.scss";
import { FileService } from "src/utils/file.service";
import pluralize from "pluralize";

const DashboardMetrics = () => {
  const loading = useSelector((state: any) =>
    _.get(state.coaching, "reports.learnings.dashboard.loading"),
  );

  const metrics = useSelector((state: any) =>
    _.get(state.coaching, "reports.learnings.dashboard.item", null),
  );

  const [metricsData, setMetricsData] = useState<
    { label: string; value: any }[]
  >([]);

  useEffect(() => {
    if (metrics) {
      const metricsData = [
        {
          label: "learnings published",
          value: metrics["learningsPublished"] || 0,
        },
        {
          label: "learners assigned",
          value: metrics["learnersAssigned"] || 0,
        },
        {
          label: "learnings completed",
          value: metrics["learningsCompleted"] || 0,
        },
        {
          label: "learners completed",
          value: metrics["learnersCompleted"] || 0,
        },
        {
          label: "total time spent",
          value: metrics["duration"] || 0,
        },
      ];

      setMetricsData(metricsData);
    }
  }, [metrics]);

  if (loading) {
    return (
      <div className={styles.dashboardContainer}>
        <div className={styles.metricsRow}>
          {_.times(6, (index) => (
            <PlaceholderDashboardCard key={index} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.metricsRow}>
        <DashboardCard value={metrics.learningsPublished || 0} label={`${pluralize("learning",metrics.learningsPublished)}  enrolled`} icon="paperflite-rocket" />
        <DashboardCard value={metrics.learnersAssigned || 0} label={`${pluralize("enrollment",metrics.learnersAssigned)}`} icon="paperflite-user-settings" />
        <DashboardCard value={metrics.learningsCompleted || 0} label={pluralize("completion",metrics.learningsCompleted)}icon="paperflite-tick-unselected" />
        <DashboardCard value={FileService.formatDuration(metrics.duration || 0, 'short')} label="time spent" icon="paperflite-clock" />
      </div>
    </div>
  );
};

export default DashboardMetrics;

interface DashboardCardProps {
  icon: string;
  label: string,
  value: any;
}

const DashboardCard: React.FC<DashboardCardProps> = ({ icon, label, value }) => {
  return (
    <div className={styles.metricCard}>
      <div className={styles.metricHeader}>
        <div className={styles.metricValue}>{value}</div>
      </div>
      <div className={styles.metricFooter}>
        <div className={styles.metricLabel}>{label}</div>
        <i className={cx(styles.icon, icon)} />
      </div>
    </div>
  );
};

const PlaceholderDashboardCard: React.FC<object> = () => {
  return (
    <div className={cx(styles.metricCard, styles.placeholder)}>
      <div className={cx(styles.metricHeader, styles.block)}>
        <div className={cx(styles.metricValue, styles.block)}> </div>
      </div>
      <div className={cx(styles.metricFooter, styles.block)}>
        <div className={cx(styles.metricLabel, styles.block)}> </div>
        <i className={cx(styles.icon, styles.block)} />
      </div>
    </div>
  );
};
